import { render, staticRenderFns } from "./TastingListQuestion.vue?vue&type=template&id=f6c90c08&scoped=true&"
import script from "./TastingListQuestion.vue?vue&type=script&lang=js&"
export * from "./TastingListQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TastingListQuestion.vue?vue&type=style&index=0&id=f6c90c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c90c08",
  null
  
)

export default component.exports